/**
 * Нормализация ответа GET finansist/catalog/contragents.
 */
export const normalizeFinansistCatalogContragents = (data) => {
  const raw = Array.isArray(data)
    ? data
    : data?.listContragent ??
      data?.listContragents ??
      data?.contragents ??
      data?.items ??
      [];

  return raw
    .map((item) => {
      const id = Number(
        item.contragentId ??
          item.contragent_id ??
          item.id ??
          item.finansist_contragent_id,
      );
      const name =
        item.name ??
        item.contragentName ??
        item.contragent_name ??
        item.finansist_contragent_name ??
        (Number.isFinite(id) ? String(id) : "");
      return { value: id, label: name, raw: item };
    })
    .filter((o) => Number.isFinite(o.value) && o.value > 0 && o.label);
};

export const emptyFinansistContragentFormState = () => ({
  finansistContragent: null,
});

export const formatMatchedFio = ({ surname, name, patronymic }) =>
  [surname, name, patronymic].filter((part) => part?.trim()).join(" ").trim();

/** Маппинг из ответа GET auth/{user_id}. */
export const getUserFinansistContragentMapping = (user) => {
  if (!user || typeof user !== "object") return null;
  return (
    user.finansist_contragent_mapping ??
    user.finansist_contragent_mappings ??
    null
  );
};

export const contragentMappingToFormState = (mapping) => {
  if (!mapping || typeof mapping !== "object") {
    return emptyFinansistContragentFormState();
  }

  const finansistId = Number(mapping.finansist_contragent_id);
  if (!Number.isFinite(finansistId) || finansistId <= 0) {
    return emptyFinansistContragentFormState();
  }

  return {
    finansistContragent: {
      value: finansistId,
      label: mapping.finansist_contragent_name || String(finansistId),
    },
  };
};

export const isFinansistContragentMappingChanged = (
  currentFormState,
  user,
) => {
  const original = contragentMappingToFormState(
    getUserFinansistContragentMapping(user),
  );
  const currentId = currentFormState?.finansistContragent?.value ?? null;
  const originalId = original?.finansistContragent?.value ?? null;
  return Number(currentId || 0) !== Number(originalId || 0);
};

/**
 * Собрать тело finansist_contragent_mapping для POST auth/register и PUT auth/{user_id}.
 */
export const buildFinansistContragentMappingPayload = ({
  finansistContragent,
  matchedFio,
}) => {
  if (!finansistContragent?.value) {
    return null;
  }

  const fio = matchedFio?.trim() || finansistContragent.label;

  return {
    finansist_contragent_id: Number(finansistContragent.value),
    finansist_contragent_name: finansistContragent.label,
    matched_fio: fio,
    is_active: true,
  };
};
